import { writable } from "svelte/store";
export const deviceStats = writable({
    online: 0,
    total: 0,
});
